module.exports = __webpack_public_path__ + "img/graphic-left@2x.833e122f.png";